export const HOURS_SELECT = Array.from({length: 24}).map((_, idx) => {
    const str = `${idx < 10 ? `0${idx}` : idx}`
    return {
        value: str,
        label: str
    }
})

export const MINUTES_SELECT = Array.from({length: 4}).map((_, idx) => {
    const minutesObj: any = {
        0: '00',
        1: '15',
        2: '30',
        3: '45'
    }
    const minutes =  minutesObj[idx % 4]
    return {
        value: minutes,
        label: minutes
    }
})
